import { render, staticRenderFns } from "./popoverLangsComp.vue?vue&type=template&id=64fa3742&scoped=true"
import script from "./popoverLangsComp.vue?vue&type=script&lang=js"
export * from "./popoverLangsComp.vue?vue&type=script&lang=js"
import style0 from "./popoverLangsComp.vue?vue&type=style&index=0&id=64fa3742&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa3742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/compass-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fa3742')) {
      api.createRecord('64fa3742', component.options)
    } else {
      api.reload('64fa3742', component.options)
    }
    module.hot.accept("./popoverLangsComp.vue?vue&type=template&id=64fa3742&scoped=true", function () {
      api.rerender('64fa3742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popoverLangsComp.vue"
export default component.exports